import { render, staticRenderFns } from "./Dzsw.vue?vue&type=template&id=01ae3fa0&scoped=true"
import script from "./Dzsw.vue?vue&type=script&lang=js"
export * from "./Dzsw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ae3fa0",
  null
  
)

export default component.exports